export enum RFQStatus {
  OPEN = 1,
  DRAFT = 4,
  CLOSED = 5,
}
